<template>
  <main class="page-wrapper">

    <h1 class="page-header mb-4">Helpo</h1>
    <article class="pb-16">
      <h2 class="font-semibold text-xl">Mallongigita regularo por tiuj kiuj jam scias ludi Skrablon</h2>
      <p class="text-slate-600 dark:text-slate-400 italic">
        Se vi ne scias kiel ludi Skrablon bonvolu unue legi la sekvan sekcion
            "Kompleta regularo".
      </p>

      <h3 class="font-semibold mt-8 mb-4">Regularaj diferencoj inter 7 Literoj kaj Skrablo: </h3>

      <ul class="list-disc list-inside">
        <li>7 literoj estas nur por 2 ludantoj.</li>
        <li>Pozicioj de koloritaj ĉeloj estas malsamaj.</li>
        <li>Estas unu stelo sur la tabulo, kies okupanto gajnas 25 kromajn poentojn.</li>
        <li> Ĉiu ludanto devas fari sian movon en fiksita tempo. Nun ĝi estas 72 horoj. Se ludanto kiu havas la vicon
          ne faras sian movon en tiu tempo, li malvenkas. 7 Literoj estis dezajnita kiel malrapida ludo, do estas tute
          normale ke kelkaj matĉoj povas dauri plurajn tagojn, kaj eĉ semajnojn. </li>
        <li> Kreanto de ĉiu ludo decidas se radika formo de vortoj estas akcepteblaj aŭ ne. Kiam radikoj estas
          akceptataj, "kat", "nigr", "vid" k.t.p ekestas validaj. La sistemo kontrolas la vortaron por vortoj kun +o,
          +a, +e kaj +i finaĵoj. </li>
        <li> Se okazas 3 sinsekvaj pretersaltoj de vicoj la ludo aŭtomate finiĝas. Poentaro decidos la venkanton. </li>
        <li> Ĉiu vorto skribita estas aŭtomate kontrolita kontraŭ <a target="_blank" href="https://vortaro.net">Plena
            Ilustrita Vortaro de Esperanto</a>. Validaj vortoj estas nur tiuj kiuj troviĝas tie kaj la sistemo rifuzas
          nevalidajn vortojn. La vortoj estas kontrolitaj post kiam ludanto klopodis formi vortojn. Tiu signifas ke,
          malsimile al Skrablo, <strong>vi rajtas elpensi kaj provi skribi vortojn kiujn eĉ vi ne konas</strong>, kaj poste
          lerni ilian signifon per kontrolado de la integrita vortaro. </li>
      </ul>

      <hr>

      <h3 class="font-semibold mt-8 mb-4">Kompleta regularo</h3>
      <ol class="list-inside list-decimal">
        <li> Almetante sur la tabulon du aŭ pli da siaj literoj, la unua ludanto formas vorton aŭ vertikale aŭ
          horizontale. Horizontalaj vortoj devas esti legeblaj de maldekstra dekstren kaj vertikalaj vortoj de supra
          malsupren. Unu litero devas esti sur la mezo de la tabulo. Ne eblas skribi diagonale. </li>
        <li> Premu la butonon kun <i class="fas fa-play-circle"></i> simbolo por registri la vorton. Vi gajnos
          poentojn, via vico pasos, kaj vi ricevos novajn literojn kiuj replenigos vian "manon" je 7 literoj. </li>
        <li> Post la unua vico, ludantoj formas novajn vortojn sur la tabulo per aldonado de unu aŭ pluraj literoj al jam
          kuŝantaj literoj. Ĉiu litero devas esti parto de valida vorto. Se pli ol unu litero estos uzata ĉiuj literoj
          devas kuŝi tiel ke ili formos linion, (t.e., ili kuŝu laŭ nur unu direkto). Se tiuj novaj literoj tuŝas
          aliajn literojn, ili ankaŭ devas formi validajn vortojn, horizontale aŭ vertikale, kvazaŭ krucvortenigmo. La
          ludanto ankaŭ gajnos poentojn por tiaj kromaj vortoj. </li>
        <li> Ĉiu litero, post la vico en kiu ĝi estis ludita restas tie ĝis la fino de la ludo. </li>
        <li>Estas du blankaj tegoletoj kiuj povas roli kiel iu ajn litero. Kiu ludas ĝin devas elekti la literon kiun
          la blanka tegoleto reprezentos. Ne eblas reelekti la literon post la vico. </li>
        <li> En via vico, vi rajtas ŝanĝi kelkajn aŭ ĉiujn viajn literojn. Premu la butonon kun <i
            class="fas fa-ellipsis-h"></i> simbolo kaj elektu "Pasigi / ŝanĝi". La programaro montros al vi direktojn
          elekti literojn nebezonatajn. Tiu finos vian vicon. Vi ankaŭ povas elekti nur pasigi la vicon sen ŝanĝo de
          literoj.

          <h3 class="font-semibold my-4">Akiri poentojn</h3>
        </li>
        <li> Ludanto gajnas poentojn por ĉiu tegoleto kiun li ludis dum la vico. Krome, li ankaŭ gajnas poentojn de
          tegoletoj kiuj jam estis kuŝantaj sed nun kreis novajn vortojn ĉi-vice. </li>
        <li> Koloritaj ĉeloj donas kromajn poentojn. L2 kaj L3 ĉeloj donas duoblan (L2) kaj trioblan (L3) poentojn de
          litero kiu kuŝas sur ili. </li>
        <li> V2 kaj V3 donas duoblan (V2) kaj trioblan (V3) poentojn de vortoj kiu uzas tiujn ĉelojn. Se vorto ankaŭ
          trafas L2 aŭ L3 ĉeloj, poentoj gajnotoj de tiuj ĉeloj estas kalkulataj <strong>antaŭ</strong> ol duobligi aŭ triobligi
          la poentojn de vortoj. Simile, se oni trafas pli ol unu V2 aŭ V3 ĉeloj kun vorto, la poentoj de vorto
          multipliĝis per ĉiu tia ĉelo trafita. </li>
        <li>Koloritoj ĉeloj funkcias nur dum la vico en kiu ili estis ekokupitaj. Literoj sur ili daŭre kontribuas
          ilian propran poenton ĉiam kiam ili kreas novajn vortojn. </li>
        <li> Kiam pli ol unu vorto estas formitaj, komunaj literoj kiuj kreis 2 vortojn aldonas poentojn por ĉiu vorto
          ili kreis. Se tiu komuna litero estas enmetita sur kolorita ĉelo, la bonuso ankaŭ kontribuas dufoje la
          poentojn por ambaŭ vortoj. </li>
        <li>Se vi uzas ĉiujn 7 literojn, vi gajnas kromajn 50 poentojn.</li>
        <li> Kiam ludo finiĝas normale (pro elĉerpo de tegoletoj aŭ 3 sinsekvaj pasigoj de vico), poentoj de literoj
          restantaj en la mano de ĉiu ludanto estas subtrahataj de poentoj de tiu kiu tenas ilin. Plie, se estas
          ludanto kiu ne havas ceteran literon (kiu fakte finis la ludon) gajnas poentojn la kontraŭulo perdis pro
          siaj restantaj literoj. </li>
        <li> Venkanto estas kiu havas pli da poentoj kiam la ludo finiĝis. Matĉoj povas finiĝi egalstate kiam ambaŭ
          ludantoj gajnis la saman poentaron. </li>
      </ol>
    </article>
  </main>
</template>

<style scoped>
  p, h2 {
    @apply mb-4;
  }

  hr {
    @apply my-8;
  }

  li {
    @apply mb-4;
  }

  strong {
    @apply font-bold;
  }
</style>